import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { ApiService } from './services/api.service';
import { NgxLoadingModule } from 'ngx-loading';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxLoadingModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  public loading: boolean = false;
  public user: any = null;

  constructor(private _api: ApiService, public _router: Router) {
    console.log('AppComponent constructor');
  }

  ngOnInit(): void {
    console.log('AppComponent ngOnInit');
  }

  ngOnDestroy(): void {
    console.log('AppComponent ngOnDestroy');
  }

  public loaderOnRouteChange(): void {
    this._router.events.subscribe(async (val: any) => {
      if (val instanceof NavigationStart) {
        this.loading = true;
      }

      if (val instanceof NavigationEnd) {
        this.loading = false;
      }
    });
  }
}
